// extracted by mini-css-extract-plugin
export var shake = "_18-0";